<template>
  <section>
    <div class="container" v-if="playerDirty">
      <span @click="toggleShown" class="toggleButton">
        <iconify-icon class="fa" 
        :icon="playerShown ? 'fa6-solid:chevron-down' : 'fa6-solid:chevron-up'"></iconify-icon>
        <span class="sr-only">Show/hide player</span>
      </span>
      <div class="playerModule" v-show="playerShown">
        <player-container
          :playingEpisode="playingEpisode"
          :audioSource="audioSource"
          v-if="playingEpisode"
        ></player-container>
        <player-placeholder v-else></player-placeholder>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import PlayerContainer from './PlayerContainer'
import PlayerPlaceholder from './PlayerPlaceholder'

export default {
  name: 'player',
  data () {
    return {
      seeking: false,
      seekingTime: null,
      playerShown: true,
      loading: true,
      error: false
    }
  },
  components: {
    PlayerContainer,
    PlayerPlaceholder
  },
  methods: {
    toggleShown () {
      this.playerShown = !this.playerShown
    }
  },
  computed: {
    audioSource () {
      if (this.playingEpisode && this.playingEpisode.audioSource) {
        return this.playingEpisode.audioSource
      }
    },
    ...mapGetters([
      'playingEpisode',
      'playerPlaying',
      'playerDirty'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins
section
  position: fixed
  bottom: 0
  left: 0
  width: 100%
  z-index: 19
  background: #fff
  box-shadow: 0 0 10px rgba(0,0,0,0.16)
  padding: 0 20px
  .container
    position: relative
    width: 100%

.toggleButton
  position: absolute
  transform: translate(-21px, -100%)
  padding: 5px 8px
  font-size: 18px
  height: auto
  line-height: 1
  background: #fff
  border: 1px solid rgba(0,0,0,0.16)
  border-bottom: none
  +tablet
    transform: translate(-100%, -100%)
</style>



// WEBPACK FOOTER //
// Player.vue?afd2adf6